<div class="modal-header">
    <h4 class="modal-title">Family Members List & Registration</h4>
    <button type="button" class="close" aria-label="Close" (click)="onClose()">
        <span aria-hidden="true">&times;</span>
    </button>
    <!-- <button type="button" class="close" aria-label="Close" (click)="onBack()">
        <span aria-hidden="true">&times;</span>
    </button> -->
</div>
<div class="modal-body">
    <div class="container-fluid">
        <form [formGroup]="familyForm" (ngSubmit)="onSubmit($event)" >
            <div class="row">
                <div class="col-xl-3">
                    <div class="form-group">
                        <label class="control-label">First Name <span class="text-danger">*</span> </label>
                        <input type="text" autocomplete="off" formControlName="first_name"
                            class="form-control form-control-sm text-uppercase"   onkeypress='return ((event.charCode >= 65 && event.charCode <= 90) ||
                            (event.charCode >= 97 && event.charCode <= 122)|| event.charCode == 32)' [ngClass]="{ 'is-invalid': submitted && f.first_name.errors }"
                           >
                          
                       <div *ngIf="submitted && f.first_name.errors" class="invalid-feedback">
                            <div *ngIf="f.first_name.errors.required"> First Name is required</div>
                        </div>
                    </div>
                </div>
                <div class="col-xl-3">
                    <div class="form-group">
                        <label class="control-label"> Last Name </label>
                        <input type="text" autocomplete="off" formControlName="last_name"
                            class="form-control form-control-sm text-uppercase"   onkeypress='return ((event.charCode >= 65 && event.charCode <= 90) ||
                            (event.charCode >= 97 && event.charCode <= 122)|| event.charCode == 32)' 
                           >
                          
                       <!-- <div *ngIf="submitted && f.last_name.errors" class="invalid-feedback">
                            <div *ngIf="f.last_name.errors.required"> Last Name is required</div>
                        </div> -->
                    </div>
                </div>
                <div class="col-xl-3">
                    <div class="form-group">
                        <label class="control-label">Email </label>
                        <div>
                            <input type="text" autocomplete="off" maxlength="60" class="form-control form-control-sm"
                                formControlName="email"   [ngClass]="{ 'is-invalid': submitted && f.email.errors }"
                               >
                            <div *ngIf="submitted && f.email.errors" class="invalid-feedback">
                                <div *ngIf="f.email.errors.pattern">Enter Valid Email</div>
                            </div>
                        </div>
                    </div>
                 
                </div>
                <div class="col-xl-3">
                    <div class="form-group">
                        <label class="control-label"> Mobile Number </label>
                        <div>
                            <input type="text" autocomplete="off" formControlName="mobile" id=" mobile"
                            maxlength="10"
                            onkeypress='return (event.charCode >= 48 && event.charCode <= 57)' [pattern]="mobPtrn"
                                class="form-control form-control-sm"   [ngClass]="{ 'is-invalid': submitted && f.mobile.errors }" >
                                <div *ngIf="submitted && f.mobile.errors" class="invalid-feedback">
                                    <div *ngIf="f.mobile.errors.pattern">Mobile Number {{mobErrMsg}}</div>
                                </div>
                        </div>
                    </div>
                  
                </div>
                <div class="col-xl-3">
                    <div class="form-group">
                        <label class="control-label">Age <span class="text-danger">*</span> </label>
                        <input type="text" autocomplete="off" formControlName="age"
                            onkeypress='return(event.charCode >= 48 && event.charCode <= 57)'
                            class="form-control form-control-sm text-uppercase" maxlength="3"  [ngClass]="{ 'is-invalid': submitted && f.age.errors }">
                            <div *ngIf="submitted && f.age.errors" class="invalid-feedback">
                                <div *ngIf="f.age.errors?.required">Age is required</div>
                            </div>
                    </div>
                </div>
               
                <div class="col-xl-3">
                    <div class="form-group">
                        <label class="control-label">Gender <span class="text-danger">*</span> </label>
                        <div>
                            <select class="form-control form-control-sm" formControlName="gender_id"  [ngClass]="{ 'is-invalid': submitted && f.gender_id.errors }"
                            (change)="genderChange($event.target.value)">
                                <option value="" selected>Select</option>
                                <option  *ngFor="let gen of genderList" [value]="gen.id" >{{gen.gender_name}}</option>          
                            </select>
                            <div *ngIf="submitted && f.gender_id.errors" class="invalid-feedback">
                                <div *ngIf="f.age.errors?.required">Gender is required</div>
                            </div>      
                            </div>
                        </div>
                    </div>
                    <div class="col-xl-3">
                        <div class="form-group">
                            <label class="control-label">Relation <span class="text-danger">*</span> </label>
                            <div>
                                <select class="form-control form-control-sm"  formControlName="relation_id" [ngClass]="{ 'is-invalid': submitted && f.relation_id.errors }" >
                                    <option value="" selected>Select</option> 
                                    <option  *ngFor="let rel of relationList" [value]="rel.id">{{rel.relation}}</option>                         
                                </select>
                                <div *ngIf="submitted && f.relation_id.errors" class="invalid-feedback">
                                    <div *ngIf="f.relation_id.errors?.required">Relation is required</div>
                                </div>  
                                </div>
                            </div>
                        </div>
                        <div class="col-xl-3" *ngIf="isEnableCasteInPtReg">
                    <div class="form-group">
                        <label class="control-label">Caste Category<span class="text-danger">*</span> </label>
                        <div>
                            <select class="form-control form-control-sm" formControlName="caste_id"
                                [ngClass]="{ 'is-invalid': submitted && f.caste_id.errors }">

                                <option value="" selected hidden>Select</option>
                                <option *ngFor="let item of casteList" [value]="item.id">{{item.caste}}</option>
                            </select>
                            <div *ngIf="submitted && f.caste_id.errors" class="invalid-feedback">
                                <div *ngIf="f.caste_id.errors.required">This field is required</div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-xl-3 mt-4" *ngIf="isEnableTribalSubPlanInPtReg">
                    <div class="form-check mt-2">
                        <input class="form-check-input" type="checkbox" id="tspCheckbox" formControlName="tribal_sub_plan">
                        <label class="form-check-label" for="tspCheckbox">
                            Tribal Sub-Plan (TSP)
                        </label>
                    </div>
                </div>

                <div class="col-xl-3" *ngIf="isEnablePregnancyStatusInReg && familyForm.value.gender_id == '2'">
                    <div class="form-group">
                        <label class="control-label">Pregnancy Status<span class="text-danger">*</span> </label>
                        <div>
                            <select class="form-control form-control-sm" formControlName="is_pregnancy"
                                [ngClass]="{ 'is-invalid': submitted && f.is_pregnancy.errors }">

                                <option value="" selected hidden>Select</option>
                                <option value="1">YES</option>
                                <option value="2">NO</option>
                                <!-- <option *ngFor="let gen of genderList" [value]="gen.id">{{gen.gender_name}}</option> -->
                            </select>
                            <div *ngIf="submitted && f.is_pregnancy.errors" class="invalid-feedback">
                                <div *ngIf="f.is_pregnancy.errors.required">This field is required</div>
                            </div>
                        </div>
                    </div>
                </div>
                        <div class='col-xl-3' *ngIf="EnablePatientCreatedDate">
                            <div class="form-group">
                                <div class='date' id='datetimepicker7'>
                                    <label class="control-label">Created Date </label>
                                    <div>
                                        <input id="backwardDate " name="backwardDate " type="text" autocomplete="off"
                                            onpaste="return false" placeholder="DD-MM-YYYY" bsDatepicker
                                            [(ngModel)]="backwardDate " [ngModelOptions]="{standalone: true}"
                                            [minDate]="min_dates"
                                            [maxDate]="max_dates" 
                                            #dp1="bsDatepicker" 
                                            [bsConfig]="{ dateInputFormat: 'DD-MM-YYYY', showWeekNumbers: false, adaptivePosition: true,isAnimated: true }"
                                            class="form-control form-control-sm"
                                            onkeypress='return event.charCode == 8'>
                        
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-xl-3 mt-2">
                            <div class="form-group">
                                <label class="control-label"><span class="text-danger"></span> </label>
                                <div>
                                    <input type="submit" class="btn btn-sm btn-primary" value="Add Family Member" >&nbsp;&nbsp;
                                    </div>
                                </div>
                            </div>
                </div>
        </form>
    </div>
    <div class="table-responsive">
        <table datatable [dtOptions]="dtOptions" *ngIf="dtRender" class="table table-striped table-bordered table-sm">
            <thead>
                <tr>
                    <th>S No </th>
                    <th>Patient Name</th>
                    <th>Mobile</th>
                    <th>Email</th>
                    <th>Gender</th>
                    <th>Age</th>
                    <!-- <th *ngIf="showCard== true && menuItems.isVle ">Health Card</th> -->
                    <th *ngIf="+roleId==7">POC</th>
                    <th *ngIf="+roleId!=14">EHR</th>
                    <!-- <th *ngIf="+roleId==14 || roleId==5 " colspan="4">Action</th> -->
                    <th colspan="4">Action</th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let item of familyLists; let i=index">
                    <td style="width: 8%;" class="text-center">{{i+1}}</td>
                    <td>{{item.member_name | uppercase}}</td>
                    <td>{{item.mobile}}</td>
                    <td>{{item.email}}</td>
                    <td *ngIf="item.gender_id == 1">Male</td>
                    <td *ngIf="item.gender_id == 2">Female</td>
                    <td *ngIf="item.gender_id == 3">Transgender</td>
                    <td>{{item.age}}</td> 
                    <!-- <td *ngIf="showCard== true && menuItems.isVle "><button class="btn btn-success btn-sm ml-5"  (click)="memberHCDwnld(item)"><span><i class="fas fa-download"></i></span></button></td> -->
                    <td *ngIf="+roleId==7">
                        <button class="btn btn-sm btn-success btn-responsive" (click)="OfflinePocSubmit(item)">POC</button>
                         

                        
                    </td>
                    <!-- New lines added for family member EHR 11-05-2022 #chandu" -->
                    <td *ngIf="+roleId!=14"><button class="btn btn-sm btn-success btn-responsive" (click)="getpatientid(item)">EHR</button>
                    </td>
                    <!-- End lines family member EHR -->
                    <td *ngIf="+roleId==14"> 
                        <button *ngIf="+roleId==14" class="btn btn-sm btn-success ml-1" (click)="openBookAppointments(item)"  data-toggle="modal" data-target="#bookappointments">Book Appointment</button>
                        <!-- <button class="btn btn-sm btn-success ml-1" (click)="opendoclist(item)">Call</button> -->
                    </td>
                    <td > 
                       <button class="btn btn-sm btn-success ml-1" (click)="opeNcdModal(item)" *ngIf="isEnableNCDscreening">NCD</button>
                        <button class="btn btn-sm btn-success ml-1"
                          (click)="onBillDetails(item)" *ngIf="+roleId==5">Add Services</button>
                          <button  class="btn btn-sm btn-success  ml-1" (click)="getpid(item)"  data-toggle="modal" data-target="#vitalscaptureFamily">Capture Vitals</button>
                          <button *ngIf="+roleId==14 || +roleId==74 || +roleId==7" class="btn btn-sm btn-success  ml-1" type="button" (click)="openVitalFileModal(item.id)">
                           <i class="" aria-hidden="true"></i> View Vitals History
                            </button>
                    </td>
                </tr>
            </tbody>
        </table> 
    </div>
</div>

<div class="modal fade" data-backdrop="static" data-keyboard="false" style="z-index: 99999 !important;"
id="vitalscaptureFamily" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
<div class="modal-dialog modal-lg" role="document">
  <div class="modal-content">
    <div class="modal-header">
      <!-- <h5 class="modal-title" id="exampleModalLabel">Patient History</h5> -->
      <button type="button" class="close" data-dismiss="modal" aria-label="Close">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div class="modal-body">
      <form [formGroup]="patvitals" autocomplete="off">
      <div>
          <div class="card mt-1 shadow cardrounded h-100">
            <div class="card-header"><strong> Vitals </strong></div>
            <div class="card-body">
              <div class="form-row small">
               
                <div class="form-group col-md-6">
                  <label for="inputEmail4">Temperature</label>
                  <div class="input_wrapper">
                    <input type="text" formControlName="temperature" id="temperature"
                      (change)="onTempChng($event.target.value)" maxlength="5"
                      onkeypress='return (event.charCode >= 48 && event.charCode <= 57) || event.charCode == 46'
                      [ngClass]="{ 'is-invalid': submitted1 && fc.temperature.errors }"
                      class="form-control form-control-sm text-uppercase" (keyup)="onTempChng($event.target.value)" />
                    <div class="unit">&deg; F</div>
                    <div *ngIf="patvitals.get('temperature').errors" class="invalid-feedback">
                      <div>Accept value from 70 to 120</div>
                    </div>
                    <div *ngIf="tempErrMsg" class="invalid-feedback">
                      <div> Enter Valid Decimal format. Eg.: 98.7 or 100.2 </div>
                    </div>
                  </div>
                </div>
                <div class="form-group col-md-6">
                  <label for="inputEmail4">Sugar(mg/dl)</label>
                  <div class="input_wrapper">
                    <input type="text" autocomplete="off" formControlName="diabetic_value" id="diabetic_value"
                      onkeypress='return (event.charCode >= 48 && event.charCode <= 57) ' maxlength="3"
                      class="form-control form-control-sm text-uppercase"
                      [ngClass]="{ 'is-invalid': submitted1 && fc.diabetic_value.errors }">
                      <div *ngIf="patvitals.get('diabetic_value').errors" class="invalid-feedback">
                          <div *ngIf="patvitals.get('diabetic_value').errors.min">Accept value from 35 to 380
                          </div>
                          <div *ngIf="patvitals.get('diabetic_value').errors.max">Accept value from 35 to 380
                          </div>
                          <div *ngIf="patvitals.get('diabetic_value').errors.required">Sugar is required</div>
                        </div>
                    </div>
                  </div>
                </div>
                <div class="form-row small">
                <div class="form-group col-md-6">
                  <label for="inputEmail4">Systolic</label>
                  <div class="input_wrapper">
                    <input type="text" autocomplete="off" formControlName="systolic" id="systolic"
                      (keyup)="keyUp('systolic')" (change)="onSysDia()"
                      onkeypress='return (event.charCode >= 48 && event.charCode <= 57)' maxlength="3"
                      [ngClass]="{ 'is-invalid': submitted1 && fc.systolic.errors }"
                      class="form-control form-control-sm text-uppercase">
                    <div class="unit">mmHg</div>
                    <div *ngIf=" patvitals.get('systolic').errors" class="invalid-feedback">
                      <div *ngIf="patvitals.get('systolic').errors.min">Accept value from 50 to 400</div>
                      <div *ngIf="patvitals.get('systolic').errors.max">Accept value from 50 to 400</div>
                      <div *ngIf="patvitals.get('systolic').errors.sys">Enter Valid Value</div>
                      <div *ngIf="patvitals.get('systolic').errors.required">Systolic is required</div>
                    </div>
                  </div>
                </div>
                <div class="form-group col-md-6">
                  <label for="inputEmail4">Diastolic</label>
                  <div class="input_wrapper">
                    <input type="text" autocomplete="off" formControlName="diastolic" id="diastolic"
                      (keyup)="keyUp('diastolic')" (change)="onSysDia()"
                      onkeypress='return (event.charCode >= 48 && event.charCode <= 57) ' maxlength="3"
                      [ngClass]="{ 'is-invalid': submitted1 && fc.diastolic.errors }"
                      class="form-control form-control-sm text-uppercase">
                    <div class="unit">mmHg</div>
                    <div *ngIf=" patvitals.get('diastolic').errors" class="invalid-feedback">
                      <div *ngIf="patvitals.get('diastolic').errors.min"> Accept value from 30 to 200
                      </div>
                      <div *ngIf="patvitals.get('diastolic').errors.max"> Accept value from 30 to 200
                      </div>
                      <div *ngIf="patvitals.get('diastolic').errors.dia">Diastolic should be less than
                        Systolic</div>
                      <div *ngIf="patvitals.get('diastolic').errors.required">Diastolic is required</div>
                    </div>
                  </div>
                </div>
            </div>
            <div class="form-row small">
                <div class="form-group col-md-6">
                  <label for="inputEmail4">Pulse</label>
                  <div class="input_wrapper">
                    <input type="text" autocomplete="off" formControlName="pulse" id="pulse" (keyup)="keyUp('pulse')"
                      onkeypress='return (event.charCode >= 48 && event.charCode <= 57)' maxlength="3" max="200"
                      [ngClass]="{ 'is-invalid': submitted1 && fc.pulse.errors }"
                      class="form-control form-control-sm text-uppercase">
                    <div class="unit">bpm</div>
                    <div *ngIf=" patvitals.get('pulse').errors" class="invalid-feedback">
                      <div *ngIf="patvitals.get('pulse').errors.min">Accept value from is 30 to 200</div>
                      <div *ngIf="patvitals.get('pulse').errors.max">Accept value from is 30 to 200</div>
                    </div>
                  </div>
                </div>
                <div class="form-group col-md-6">
                  <label for="inputEmail4">SPO2%</label>
                  <div class="input_wrapper">
                    <input type="text" autocomplete="off" formControlName="oxigen_count" id="oxigen_count"
                      onkeypress='return (event.charCode >= 48 && event.charCode <= 57) ' maxlength="3"
                      [ngClass]="{ 'is-invalid': submitted1 && fc.oxigen_count.errors }"
                      class="form-control form-control-sm text-uppercase"
                      >
                    <div *ngIf="patvitals.get('oxigen_count').errors" class="invalid-feedback">
                      <div *ngIf="patvitals.get('oxigen_count').errors.min">Accept value from 40 to 205
                      </div>
                      <div *ngIf="patvitals.get('oxigen_count').errors.max">Accept value from 40 to 205
                      </div>
                      <div *ngIf="patvitals.get('oxigen_count').errors.required">SPO2% is required</div>
                    </div>
                  </div>
                </div>
            </div>
            <div class="form-row small">
                <div class="form-group col-md-6">
                  <label for="inputEmail4">Height(cm)</label>
                  <div class="input_wrapper">
                    <input type="text" autocomplete="off" formControlName="height" id="height"
                      onkeypress='return (event.charCode >= 48 && event.charCode <= 57) ' maxlength="6"
                      [ngClass]="{ 'is-invalid': submitted1 && fc.height.errors }"
                      (keyup)="onTempChng($event.target.value)" class="form-control form-control-sm text-uppercase"
                      >
                    <div class="unit">cm</div>
                    <div *ngIf="patvitals.get('height').errors" class="invalid-feedback">
                      <div *ngIf="patvitals.get('height').errors.min">Accept value from 30 to 220.99</div>
                      <div *ngIf="patvitals.get('height').errors.max">Accept value from 30 to 220.99</div>
                    </div>
                  </div>
                </div>
                <div class="form-group col-md-6">
                  <label for="inputEmail4">Weight</label>
                  <div class="input_wrapper">
                    <input type="text" autocomplete="off" formControlName="weight" id="weight"
                      onkeypress='return (event.charCode >= 48 && event.charCode <= 57) ' maxlength="6"
                      [ngClass]="{ 'is-invalid': submitted1 && fc.weight.errors }"
                      class="form-control form-control-sm text-uppercase"
                      >
                    <div class="unit">kg</div>
                    <div *ngIf="patvitals.get('weight').errors" class="invalid-feedback">
                      <div *ngIf="patvitals.get('weight').errors.min">Accept value from 1 to 200.99</div>
                      <div *ngIf="patvitals.get('weight').errors.max">Accept value from 1 to 200.99</div>
                    </div>
                  </div>
                </div>
            </div>
            <button type="button" class="btn btn-sm btn-secondary" (click)="submitvitals()">Submit</button>
                <!-- <div class="form-group col-md-6">
                  <button class="badge badge-dark" type="button" (click)="openVitalFileModal()">
                    <i class="" aria-hidden="true"></i> <strong> View Vitals History</strong>
                  </button>
                </div> -->
            
            </div>
          </div>
        </div>
      </form>
    </div>
    <div class="modal-footer">
      <!-- <button type="button" class="btn btn-sm btn-secondary" data-dismiss="modal">Close</button> -->
      <!-- <button class="badge badge-dark" type="button" (click)="openVitalFileModal()">
          <i class="" aria-hidden="true"></i> <strong> View Vitals History</strong>
        </button> -->
    </div>
  </div>
</div>
</div>



